import type { FC } from "react"

import { cn } from "@/lib/utils"

interface Props {
  alt?: string
  className?: string
}

export const Logo: FC<Props> = ({ alt = "WarpMe", className }) => {
  return <img src="/warpme-logo.svg" alt={alt} className={cn("h-[21px] w-[81px]", className)} />
}
